import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from './components/main/PrivateRoute';
import { ApiProvider } from './contexts/ApiContext';
import { ModalProvider } from './contexts/ModalContext'; // Adjust path
import { HelmetProvider } from 'react-helmet-async';

import Login from './components/auth/Login';
import EmailLogin from './components/auth/EmailLogin';
import OTP from './components/auth/OTP';
import SetPassword from './components/auth/SetPassword';
import Logout from './components/auth/Logout';
import MainApp from './components/main/MainApp';

import CheerBuddyDashboard from './components/Marketing/Leads/Leads';
import TemplateDashboard from './components/Marketing/Templates/Templates';
import AutomationDashboard from './components/Marketing/Automations/Automations';
import WebFormsDashboard from './components/Marketing/Webforms/Webforms';
import CheerBuddy from './components/leads/Leads';
import CreateLead from './components/leads/create';
import Bulkupload from './components/leads/bulkUpload';
import Templates from './components/templates/editTemplate';
import CreateTemplate from './components/templates/createTemplate';
import CreateAutomation from './components/Automations/createAutomation';
import WebForms from './components/Webforms/Webforms';
import Report from './components/Marketing/Report/Report';
import AutomationReport from './components/Report/Automation';
import TransactionalReport from './components/Report/Transactional';
import Profile from './components/profile/Profile';
import ChangePassword from './components/profile/ChangePassword';
import Main from './components/dashboards/Main/Main';
import EmailValidationMain from './components/EmailVerifiy/emailValidationMain';
import NewValidationRequest from './components/EmailVerifiy/newValidationRequest';
import PaymentVerify from './components/EmailVerifiy/paymentVerify';


const App = () => {
  const [status, setStatus] = useState(null);
  const helmetContext = {};
  return (
    <HelmetProvider context={helmetContext}>
      <Router>
        <ApiProvider>
          <ModalProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/login/email" element={<EmailLogin
                setStatus={setStatus}
              />} />
              <Route path="/login/email/otp" element={<OTP
                status={status}
              />} />
              <Route path="/setpassword" element={<SetPassword />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="/dashboard" element={<PrivateRoute><MainApp /></PrivateRoute>} >
                <Route path='/dashboard' element={<PrivateRoute><Main /></PrivateRoute>}></Route><Route path='/dashboard/profile' element={<PrivateRoute><Profile /></PrivateRoute>}></Route>
                <Route path='/dashboard/profile/changepassword' element={<PrivateRoute><ChangePassword /></PrivateRoute>}></Route>
              </Route>
              <Route path="/tools/email-verify" element={<PrivateRoute><MainApp /></PrivateRoute>} >
                <Route path='/tools/email-verify' element={<PrivateRoute><EmailValidationMain /></PrivateRoute>}></Route>
                <Route path='/tools/email-verify/payment/verify' element={<PrivateRoute><PaymentVerify /></PrivateRoute>}></Route>
                <Route path='/tools/email-verify/new-request' element={<PrivateRoute><NewValidationRequest /></PrivateRoute>}></Route>
              </Route>
              <Route path='/Marketing/' element={<PrivateRoute><MainApp /></PrivateRoute>}>
                <Route path='/Marketing/' element={<PrivateRoute><CheerBuddyDashboard /></PrivateRoute>}></Route>
                <Route path='/Marketing/Lead' element={<PrivateRoute><CheerBuddyDashboard /></PrivateRoute>}></Route>
                <Route path='/Marketing/Lead/:LeadId' element={<PrivateRoute><CheerBuddy /></PrivateRoute>}></Route>
                <Route path='/Marketing/Lead/create' element={<PrivateRoute><CreateLead /></PrivateRoute>}></Route>
                <Route path='/Marketing/Lead/bulkupload' element={<PrivateRoute><Bulkupload /></PrivateRoute>}></Route>
                <Route path='/Marketing/Templates/' element={<PrivateRoute><TemplateDashboard /></PrivateRoute>}></Route>
                <Route path='/Marketing/Templates/create' element={<PrivateRoute><CreateTemplate /></PrivateRoute>}></Route>
                <Route path='/Marketing/Templates/view/:TemplateId' element={<PrivateRoute><Templates /></PrivateRoute>}></Route>
                <Route path='/Marketing/webforms/' element={<PrivateRoute><WebFormsDashboard /></PrivateRoute>}></Route>
                <Route path='/Marketing/webforms/:WebFormId' element={<PrivateRoute><WebForms /></PrivateRoute>}></Route>
                <Route path='/Marketing/webforms/submissions/:EntryId' element={<PrivateRoute><WebForms /></PrivateRoute>}></Route>
                <Route path='/Marketing/Automations/' element={<PrivateRoute><AutomationDashboard /></PrivateRoute>}></Route>
                <Route path='/Marketing/Automations/create' element={<PrivateRoute><CreateAutomation /></PrivateRoute>}></Route>
                <Route path='/Marketing/Report/' element={<PrivateRoute><Report /></PrivateRoute>}></Route>
                <Route path='/Marketing/Reports/transactional' element={<PrivateRoute><TransactionalReport /></PrivateRoute>}></Route>
                <Route path='/Marketing/Reports/:ReportId' element={<PrivateRoute><AutomationReport /></PrivateRoute>}></Route>
                <Route path='/Marketing/Templates/view/:TemplateId' element={<PrivateRoute><Templates /></PrivateRoute>}></Route>
              </Route>
              <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
          </ModalProvider>
        </ApiProvider>
      </Router>
    </HelmetProvider>
  );
};

export default App;
